export default "__VITE_ASSET__5aaa6471__"